import styled from "styled-components";

export const Wrapper = styled.div`
  box-shadow: rgba(27, 41, 68, 0.1) 0px 0px 20px;
  background-color: rgb(244, 245, 246);
`;
